/**
 * 2018-10-11
 * news pro modify script index
 */
import Menu from "./Module/Menu.Class";
// import TagSearch from "./Module/TagSearch.Class";
import Footer from "./Module/Footer.Class";
import NewsTabs from "./Module/NewsTabs.Class";      //20191102 XJ 新增 NewsTabs 三网首页改版 
import PhotoCarousel from "./Module/PhotoCarousel.Class";
import GenesisTabs from './Module/GenesisTabs.Class'
import FixedNavbar from './Module/FixedNavbar.Class'  // 20191112 JY添加悬浮导航
import RecommendPostWidgetHandle from "./Backend/RecommendPostWidgetHandle.Class";
import BitterWinterApp from "./Topics/MobileApp/index"
import ModifyTime20190418 from "./modify/2019-04-18"
import ModifyTime20190617 from "./modify/2019-06-17"

class NewProModify {
  constructor() {
    this.init()
  }

  init() {
    //  swtich is admin
    window._lastPostUpdateTime === undefined ? this.backend() : this.frontend();
    this._mobile_post_bottom_ad()
    this._search_can_not_empty()
    this._list_pagenav()
  }

  /**
   * handle frontend
   */
  frontend() {
    // put entry meta below the entry-content
    this._moveEntryMetaBelowTheEntryContent()
    //  set place holder
    this._setPlaceholder()
    //  set last update time
    // $('.lastUpdateTime').length > 0 && this._setLastUpdateTime()
    //  add sticky effect
    // window.setTimeout(() => this._stickyMainWithAside(), 3000)
    // window.addEventListener('load', () => this._stickyMainWithAside())  // 20191112 JY修改侧边悬浮
    //
    // handle image_alignleft layout
    this._imageAlignleftLayoutHandle()
    //  highlight menu item when children active
    this._menuHighlightHandle()
    //  add return top
    this._returnTopBtnHandle()
    //  fix header right site description new line
    this._siteDescriptionNewLineHandle()
    //  show page more category btm
    this._showPageMoreCategoryBtnHandle()
    //  mobile app area
    // $(() => $('.recommend-app-area').length > 0 && this._mobileAppArea())
    //  2019-04-15 remove  last "/" from breadcrumb
    // $('.breadcrumb .sidebar').prev().remove()

    $('#menu-main a:not([href])').click(ev => $(ev.currentTarget).next().click())

    //  Menu
    new Menu()

    // new TagSearch()
    //  Footer
    new Footer()

    //20191102 XJ 新增 NewsTabs 三网首页改版 
    // $(window).width() > 1023 && 
    new NewsTabs()

    //  mobile App
    if ($(document.body).hasClass('bitter-winter-app')) {
      new BitterWinterApp()
    }

    //  website change of 2019-04-18
    new ModifyTime20190418()
    //  website change of 2019-06-17
    new ModifyTime20190617()
  }

  /**
   * Mobile App Area
   * @private
   */
  _mobileAppArea() {
    if (!this.isMobile() || window.innerWidth >= 1024 || window.localStorage.getItem('closeAppArea') == 'true') {
      return
    }

    // html handle
    let oTarget = $('.recommend-app-area')
    $(document.body).prepend(oTarget.show())
    $(document.body).css('padding-top', 80)

    //  event handle
    oTarget.find('.js-close').click(() => {
      oTarget.velocity({
        translateY: ['-100%', 0]
      }, {
        complete: () => {
          oTarget.remove()
          $(document.body).css('padding-top', 0)
        }
      })
      window.localStorage.setItem('closeAppArea', true)
    })

    oTarget.find('.js-app-download').click(() => {
      if (this.isMobile() === 'IOS') {
        window.open(oTarget.get(0).dataset.ios, '_blank')
      } else {
        window.open(oTarget.get(0).dataset.android, '_blank')
      }
    })
  }

  isMobile() {
    let ua = navigator.userAgent
    let isAndroid = /Android/i.test(ua)
    let isIOS = /iPhone|iPad|iPod/i.test(ua)
    let isMobile = isAndroid || isIOS
    if (isAndroid) isMobile = 'android'
    if (isIOS) isMobile = 'IOS'
    this.isMobile = function () {
      return isMobile || false
    }
    return isMobile
  }

  /**
   * show page more category btm handle
   * @private
   */
  _showPageMoreCategoryBtnHandle() {
    if ($(document.body).hasClass('video-page') || $(document.body).hasClass('pictures-page')) {
      if (window.__pageMoreBtnShow) {
        $('main.content .more-from-category').show()
        //  handle src to page 2
        let oA = $('main.content .more-from-category a')
        let oldHref = oA.attr('href')
        oA.attr('href', `${oldHref}page/2`)
      }
    }
  }

  /**
   * handle backend
   */
  backend() {
    //  include recommend post handle
    new RecommendPostWidgetHandle()
  }

  /**
   * fix header right site description new line
   * @private
   */
  _siteDescriptionNewLineHandle() {
    let html = $('.site-description').html()
    $('.site-description').html(html.replace(/\\n/g, '<br/>')).velocity('fadeIn')
  }

  /**
   * return top btn handle
   * @private
   */
  _returnTopBtnHandle() {
    let oBackTop = null
    let html = `<button class="js-return-top"><span class="icon-cheveron-up"></span></button>`

    $(document.body).append(html)
    oBackTop = $('.js-return-top')
    oBackTop.css('left', this._calcReturnTopPositionLeft())

    $(window).on('scroll', () => {
      //  计算已经滚动高度
      let scrollTop = $(window).scrollTop()
      let stickyKitHeight = window.innerHeight * 1.2;

      if (scrollTop > stickyKitHeight) {
        if (!oBackTop.hasClass('show')) {
          oBackTop.addClass('show');
          oBackTop.css('opacity', 0).velocity('stop');
          oBackTop.velocity('transition.slideUpIn');
        }
      } else {
        if (oBackTop.hasClass('show')) {
          oBackTop.stop(true, false).fadeOut()
          oBackTop.removeClass('show')
        }
      }
    }).trigger('scroll')

    $(window).on('resize', () => oBackTop.css('left', this._calcReturnTopPositionLeft()))

    //  back top
    oBackTop.click(() => $(document.body).velocity('scroll'))
  }

  _calcReturnTopPositionLeft() {
    let oContent = $('.site-container-wrap')
    let left = oContent.outerWidth() + oContent.offset().left
    //  1400
    if (left + 80 > 1400) {
      return left + 80
    } else {
      return left - 80
    }
  }

  /**
   * highlight menu item when children active
   * @private
   */
  _menuHighlightHandle() {
    let pathName = window.location.pathname

    $('#menu-main ul a').map((k, el) => {
      let href = el.href
      if (~href.indexOf(pathName) && pathName != '/') {
        $(el).parents('.sub-menu').parent().addClass('active')
      }
    })
  }

  /**
   * handle image_alignleft layout
   * @private
   */
  _imageAlignleftLayoutHandle() {
    $('.standard_layout_widget.image_alignleft').map((k, el) => {
      //  http://take.ms/8Ojtk
      //
      let oA = $(el).children('a')
      let oHeader = $(el).children('.entry-header')
      let oTitle = oHeader.children('.entry-title')
      let oContent = $(el).children('.entry-content')

      oHeader.append(oA)
      oContent.prepend(oTitle)

      $(el).addClass('js-image-alignleft-layout-handled')
    })
  }

  /**
   * add sticky effect  20191112 JY修改侧边悬浮
   * @private
   */
  _stickyMainWithAside() {
    let oAside = $('#genesis-sidebar-primary')
    let oContent = $('#genesis-content')

    if (oAside.outerHeight() >= oContent.outerHeight() + 40) {
      return
    }

    let isSwitch = false

    // $('head').append('<style class="aside-sticky"></style>')
    // let oStyle = $('.aside-sticky')

    let stickySidebar = $(`<div class="sticky_sidebar"></div>`)
    stickySidebar.append(oAside.children())
    oAside.append(stickySidebar)

    $(window).resize(() => {
      //   let left = oContent.offset().left + oContent.outerWidth()
      //   oStyle.html(`
      // #genesis-sidebar-primary[sticky="stick"]{
      // left:${left}px
      // }
      // `)

      if (window.innerWidth < 1030) {
        isSwitch = false
        stickySidebar.trigger('sticky_kit:detach')
      } else {
        if (!isSwitch) {
          isSwitch = true
          setTimeout(() => {
            stickySidebar.stick_in_parent({
              parent: '.content-sidebar-wrap',
              offset_top: 20,
              spacer: ''
            })
              .on('sticky_kit:stick', ev => oAside.attr('sticky', 'stick'))
              .on('sticky_kit:unstick', ev => oAside.attr('sticky', 'unstick'))
              .on('sticky_kit:bottom ', ev => oAside.attr('sticky-bottom', 'bottom'))
              .on('sticky_kit:unbottom ', ev => oAside.attr('sticky-bottom', 'unbottom'))
          }, 500)
        }
      }
    }).trigger('resize')
  }

  /**
   * set last update time for header right
   * @private
   */
  // _setLastUpdateTime () {
  //   let oLastUpdateTime = $('.lastUpdateTime')
  //   //  Update :　[last_update_time]
  //   let sTemplate = oLastUpdateTime.html()
  //   this._getTimeFormat()
  //   oLastUpdateTime.html(sTemplate.replace('[last_update_time]', this._getTimeFormat(window._lastPostUpdateTime)))
  //   oLastUpdateTime.show().css('opacity', 1)
  // }

  /**
   * print last update time by diff lang
   * @private
   */
  // _getTimeFormat (time) {
  //   switch (window._siteLang) {
  //     case 'zh-hk':
  //     case 'ko':
  //     case 'ja':
  //       return window.moment(time, 'YYYYMMDD').format('LL');
  //       break;
  //     case 'en':
  //     case 'it':
  //     case 'fr-ch':
  //     case 'es':
  //     case 'de':
  //       return window.moment(time, 'YYYYMMDD').format('ddd, MMMM D, YYYY');
  //       break;
  //     default:
  //       return time
  //       break;
  //   }
  // }

  /**
   * set subscribe email widgets input placeholder
   * @private
   */
  _setPlaceholder() {
    $('.mc4wp-form').map((k, el) => {
      if ($(el).find('#mce-EMAIL').length > 0) {
        let oInput = $(el).find('#mce-EMAIL')
        let placeholderText = oInput.prev().text().trim()
        oInput.attr('placeholder', placeholderText)
      }
    })
  }

  /**
   * put entry meta below the entry-content , cuz i dont wanna edit origin theme code
   * @private
   */
  _moveEntryMetaBelowTheEntryContent() {
    !$(document.body).hasClass('single-post') && $('.entry-meta').map((k, el) => {
      let parent = $(el).parent()
      if (parent.hasClass('entry-header') && parent.next().hasClass('entry-content')) {
        parent.next().append(el)
      }
    })
  }

  /**
   * 移动端文章底部广告图切换 add JL 20191207
   */
  _mobile_post_bottom_ad(){
    let imgMb = $('.donate-us img').data('mb')
    let imgPc = $('.donate-us img').attr('src')
    $(window).resize(function(){
      if ($(window).width() < 768) {
        $('.donate-us img').attr('src', imgMb)
      }else{
        $('.donate-us img').attr('src', imgPc)
      }
    }).trigger('resize');
  }

  /**
   * 搜索必须输入内容才能提交  add JL 20191208
   */
  _search_can_not_empty(){
    $('.search-form').find('input[type="submit"]').prop('disabled', true);
    $('.search-form').find('input[name="s"]').keyup(function () {
      if ($(this).val().trim() != '') {
        $('.search-form input[type="submit"]').prop('disabled', false);
      }
    });
  }

  /**
   * 列表页页码处理
   */
  _list_pagenav(){
    /* $('.archive-pagination ul .screen-reader-text').remove()
    let lastNum = $('.archive-pagination ul li:nth-last-of-type(2) a').text()
    let arrLi = $('.archive-pagination ul li')
    let firstUrl = ''
    $.map(arrLi,function(v,k) {
      if($(v).find('a').text() == 1) {
        firstUrl = $(v).find('a').attr('href');
      }
    })
    if ($('.archive-pagination ul li').hasClass('.pagination-next')) {
      console.log(1);
    }else{
      console.log(2);
    } */
    $('.archive-pagination .pagination-previous a').html(`<span class="icon-arrow_left"></span>`)
    $('.archive-pagination .pagination-next a').html(`<span class="icon-arrow_right"></span>`)
    /* if (lastNum > 5) {
      $('.archive-pagination ul').prepend(`<li class="list-page pageFirst"></li>`)
      $('.archive-pagination ul').append(`<li class="list-page pageLast"></li>`)
    } */
  }
}

$(() => new NewProModify())

